export interface State {
  transactions:
    | {
        amount: number
        created_at: string
        from: {
          balances: number
          name: string
          profile_image: {
            id: string
            url: string
          }
          wallet: string
        }
        id: string
        to: {
          balances: number
          name: string
          profile_image: {
            id: string
            url: string
          }
          wallet: string
        }
        token: {
          amount: number
          balances: number
          created_at: string
          description: string
          id: string
          intro_stamp: string
          links: [
            {
              href: string
              rel: string
            }[]
          ]
          name: string
          owner: {
            created_at: string
            description: string
            id: string
            name: string
            profile_image: {
              id: string
              url: string
            }
            updated_at: string
          }
          owner_last_signed_in_at: string
          profile_image: {
            id: string
            url: string
          }
          updated_at: string
        }
      }[]
    | null
  isTransactionsLoading: boolean
}

export interface Context {
  commit: (name: string, payload: object) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {
  transactions: null,
  isTransactionsLoading: false
}

export const mutations: Mutations = {
  setTransactions(state, payload) {
    state.transactions = payload.transactions
  },
  onTransactionsLoadingStart(state) {
    state.isTransactionsLoading = true
  },
  onTransactionsLoadingFinished(state) {
    state.isTransactionsLoading = false
  }
}

export const actions: Actions = {
  async fetchTransactions({ commit }, payload) {
    commit('onTransactionsLoadingStart', {})
    const { response, error } = await this.$api.fetchTransactions()
    if (response) {
      commit('setTransactions', response)
      await this.$delay(500)
      commit('onTransactionsLoadingFinished', {})
      return
    }
    await this.$delay(500)
    commit('onTransactionsLoadingFinished', {})
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  mutations,
  actions
}
